import { Link } from 'react-router-dom';
import { PortalShell } from '@/layouts/PortalShell/PortalShell';
import { FooterChrome } from '@/layouts/FooterChrome/FooterChrome';
import { nb } from '@/i18n/nb';
import s from '@/views/Personvern/Personvern.module.css';

// Stub destination for the footer's "Min profil" link (profile editing is post-MVP).
export function Profil() {
  return (
    <PortalShell>
      <main className={s.page}>
        <h1 className={s.heading}>{nb.profil.heading}</h1>
        <p className={s.body}>{nb.profil.body}</p>
        <Link to="/" className={s.backLink}>
          {nb.profil.backToFront}
        </Link>
      </main>
      <FooterChrome />
    </PortalShell>
  );
}
